var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isInvited)?_c('invited',{attrs:{"user-id":_vm.userId}}):(_vm.isActive)?_c('q-btn',{attrs:{"label":"Active","color":"positive","flat":"","disable":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }